import Vue from 'vue';
import App from './App.vue';
import Axios from 'axios';
import { MediaQueryProvider } from 'vue-component-media-queries';
import AppRefresh from './AppRefresh.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import { convertMQsForVueComponentMediaQueriesLibrary, getBreakpoints } from './utils/breakpoints';

// import Gamebay from '@/views/Gamebay.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Meta from 'vue-meta';
// @ts-ignore
import VueSignaturePad from 'vue-signature-pad';

const queries = convertMQsForVueComponentMediaQueriesLibrary(getBreakpoints());
export { queries };


Vue.prototype.$http = Axios;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Meta);
Vue.use(VueSignaturePad);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  // render: (h) => h(App),
  render: (h) => h(MediaQueryProvider, { props: { queries } }, [ h(AppRefresh) ]),
}).$mount('#app');
